import {
    useState
} from 'react';

/**
 * useAutoApprove — whether BEXI runs writes without asking. Persisted per browser
 * in localStorage. Default ON (the user opted into auto-run).
 */
export function useAutoApprove() {
    const [autoApprove, setAutoApprove] = useState(() => {
        try { return localStorage.getItem('bexi:autoApprove') !== 'false'; } catch { return true; }
    });
    const toggleAuto = () => setAutoApprove((v) => {
        const next = !v;
        try { localStorage.setItem('bexi:autoApprove', String(next)); } catch { /* ignore */ }
        return next;
    });
    return {
        autoApprove,
        toggleAuto
    };
}
